import React, { Component } from 'react';
import { connect } from 'react-redux';
import { parse } from 'store/reducers/product';
import { axiosCms } from 'Axios.js';
import styles from './ProductPage.module.css';
import * as Page from 'HOC/Layout/PageContainer';
import ProductTable from 'components/Product/ProductTable/ProductTable';
import WithError from 'HOC/Error/WithError';
import { fetchAllProducts, fetchProducts, updateCart } from 'store/actions/index';
import { Tabs, Input } from 'antd';

const { TabPane } = Tabs;
const { Container, Title } = Page;
const { Search } = Input;

class ProductPage extends Component {
  state = {
    current: 'tiles',
    searchString: '',
  };

  componentDidMount() {
    this.props.fetchAllProducts().catch(console.error);
  }

  onTabClick = key => {
    let f = this.state.searchString;
    this.props.fetchProducts(key, f);
    this.setState(prev => ({ ...prev, current: key, searchString: f }));
  };

  updateCartHandler = keys => {
    if (keys.length !== 0 && typeof keys[0] !== typeof 0) throw new Error('unknown key type in #updateCartHandler');
    const { updateCart } = this.props;
    const { current } = this.state;
    updateCart(current, keys);
  };

  onSearchHandler = e => {
    this.setState({
      searchString: e.target.value,
    });
    let key = this.state.current;
    let f = e.target.value;
    this.props.fetchProducts(key, f);
    this.setState(prev => ({ ...prev, current: key, searchString: f }));
  };

  renderContainer = () => {
    const { isLoading } = this.props;
    return (
      <Container type="2x3">
        <Title title="Products" />
        <div className={styles.Main}>
          <Search
            id="product-search-form"
            defaultValue={this.state.searchString}
            placeholder="Input title"
            size="large"
            style={{ width: 400, marginBottom: '15px' }}
            onPressEnter={this.onSearchHandler}
          />
          <Tabs defaultActiveKey={this.state.current} onChange={this.onTabClick} type="card">
            <TabPane tab="Tiles" key="tiles">
              <ProductTable
                products={this.props.tiles}
                updateCartHandler={this.updateCartHandler}
                selectedRowKeys={this.props.tilesID}
                isLoading={isLoading}
              />
            </TabPane>
            <TabPane tab="Stone" key="stone">
              <ProductTable
                products={this.props.stone}
                updateCartHandler={this.updateCartHandler}
                selectedRowKeys={this.props.stoneID}
                isLoading={isLoading}
              />
            </TabPane>
            <TabPane tab="Countertop" key="countertop">
              <ProductTable
                products={this.props.countertop}
                updateCartHandler={this.updateCartHandler}
                selectedRowKeys={this.props.countertopID}
                isLoading={isLoading}
              />
            </TabPane>
            <TabPane tab="Mosaic" key="mosaic">
              <ProductTable
                products={this.props.mosaic}
                updateCartHandler={this.updateCartHandler}
                selectedRowKeys={this.props.mosaicID}
                isLoading={isLoading}
              />
            </TabPane>
            <TabPane tab="Wood" key="wood">
              <ProductTable
                products={this.props.wood}
                updateCartHandler={this.updateCartHandler}
                selectedRowKeys={this.props.woodID}
                isLoading={isLoading}
              />
            </TabPane>
            <TabPane tab="Vinyl" key="vinyl">
              <ProductTable
                products={this.props.vinyl}
                updateCartHandler={this.updateCartHandler}
                selectedRowKeys={this.props.vinylID}
                isLoading={isLoading}
              />
            </TabPane>
          </Tabs>
        </div>
      </Container>
    );
  };

  render() {
    // console.log(this.props);
    return this.renderContainer();
  }
}

// TODO: refactor this giant mess of a repeated stuff
const mapStateToProps = state => {
  const { product } = state;
  const { cart } = state;
  // parse data['price_cents'] to more readable format
  const parsedProducts = parse(product);
  const {
    tiles: tilesID,
    stone: stoneID,
    mosaic: mosaicID,
    wood: woodID,
    vinyl: vinylID,
    countertop: countertopID,
  } = cart;
  const isLoading = state.product.loading || state.auth.loading;
  return {
    ...parsedProducts,
    // used for selectedRowKeys and CartFooter.js
    tilesID,
    stoneID,
    mosaicID,
    woodID,
    vinylID,
    countertopID,
    isLoading,
  };
};

const mapDispatchToProps = { fetchAllProducts, fetchProducts, updateCart };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithError(ProductPage, axiosCms));



// WEBPACK FOOTER //
// ./src/containers/Product/ProductPage.js